/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */

import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import { FaCalendarAlt, FaMapMarkerAlt, FaChevronDown, FaChevronUp, FaExternalLinkAlt, FaRegClock, FaUserFriends } from "react-icons/fa";

const EventsPage = () => {
  const [activeTab, setActiveTab] = useState("upcoming");
  const [expandedEvents, setExpandedEvents] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [events, setEvents] = useState({ upcoming: [], past: [], programs: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // API URLs
  const API_EVENTS = process.env.REACT_APP_API_BASE_URL + "/UIevents";
  const API_MEDIA = process.env.REACT_APP_API_BASE_URL + "/UImedia";

  // Helper function to format date
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    } catch (e) {
      return dateString;
    }
  };

  // Helper function to check if event date is in the past compared to today
  const isEventDatePast = (eventDateString) => {
    if (!eventDateString) return false;

    try {
      const eventDate = new Date(eventDateString);
      const today = new Date();

      // Reset both dates to midnight for accurate comparison
      eventDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      return eventDate < today;
    } catch (e) {
      console.error("Error comparing dates:", e);
      return false;
    }
  };

  // Helper function to check if event date is today
  const isEventToday = (eventDateString) => {
    if (!eventDateString) return false;

    try {
      const eventDate = new Date(eventDateString);
      const today = new Date();

      // Reset both dates to midnight for accurate comparison
      eventDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      return eventDate.getTime() === today.getTime();
    } catch (e) {
      console.error("Error checking if event is today:", e);
      return false;
    }
  };

  // Helper function to check if registration should be closed
  const isRegistrationClosed = (event) => {
    if (!event.rawDate) return false;

    // Registration is closed if event date is today or past
    return isEventToday(event.rawDate) || isEventDatePast(event.rawDate);
  };

  // // Fallback events data
  // const getFallbackEvents = () => {
  //   const today = new Date();
  //   const tomorrow = new Date(today);
  //   tomorrow.setDate(today.getDate() + 1);
  //   const yesterday = new Date(today);
  //   yesterday.setDate(today.getDate() - 1);

  //   return {
  //     upcoming: [
  //       {
  //         id: 1,
  //         title: "MSME Growth Workshop",
  //         date: formatDate(tomorrow.toISOString()),
  //         rawDate: tomorrow.toISOString(),
  //         location: "MASA Headquarters, Nairobi",
  //         description: "Learn strategies for scaling your MSME business",
  //         fullDescription: "This comprehensive workshop covers all aspects of MSME growth including funding, marketing, and operations management.",
  //         image: "https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
  //         category: "upcoming",
  //         time: "9:00 AM - 4:00 PM",
  //         organizer: "MASA Forum"
  //       }
  //     ],
  //     past: [
  //       {
  //         id: 2,
  //         title: "Startup Networking Event",
  //         date: formatDate(yesterday.toISOString()),
  //         rawDate: yesterday.toISOString(),
  //         location: "Innovation Hub, Nairobi",
  //         description: "Connect with fellow entrepreneurs and investors",
  //         fullDescription: "Our successful networking event that brought together over 200 entrepreneurs and 50 investors.",
  //         image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
  //         category: "past",
  //         time: "6:00 PM - 9:00 PM",
  //         organizer: "MASA Forum"
  //       }
  //     ],
  //     programs: [
  //       {
  //         id: 3,
  //         title: "Women Entrepreneurship Program",
  //         date: "Ongoing",
  //         rawDate: new Date().toISOString(),
  //         location: "Various Locations",
  //         description: 'Year-long mentorship program for women entrepreneurs. <a href="/programs/women-entrepreneurship" class="text-teal-400 hover:text-teal-300">Learn more</a>',
  //         fullDescription: "A comprehensive 12-month program designed to empower women entrepreneurs through mentorship, training, and networking opportunities.",
  //         image: "https://images.unsplash.com/photo-1551836026-d5c2c5af78e4?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
  //         category: "program",
  //         time: "Flexible Schedule",
  //         organizer: "MASA Forum"
  //       }
  //     ]
  //   };
  // };

  // Fetch events from API
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch events from your API
        const response = await axios.get(API_EVENTS);
        const eventsData = response.data.results || response.data;

        // Categorize events based on their category field
        const categorizedEvents = {
          upcoming: [],
          past: [],
          programs: []
        };

        // console.log("Fetched Events Data:", eventsData);

        // Process each event and load images
        // Process each event and load images
        const processedEvents = await Promise.all(
          eventsData.map(async (event) => {

            if (event.isActive === false) {
              return null; // Skip inactive events
            }

            let imageUrl = event.image || "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80";

            // If event has an image ID, fetch the image from media API
            if (event.image && event.image.id) {
              try {
                const imgRes = await axios.get(`${API_MEDIA}/${event.image.id}/download`, {
                  responseType: "blob",
                });
                imageUrl = URL.createObjectURL(imgRes.data);
              } catch (imgErr) {
                console.error("Error loading image:", imgErr);
              }
            }

            return {
              id: event.id || event._id,
              title: event.title || "Untitled Event",
              date: event.date ? formatDate(event.date) : "Date not specified",
              rawDate: event.date || "", // Store the original date for comparison
              location: event.location || "Location not specified",
              description: event.description || "",
              fullDescription: event.fullDescription || "",
              image: imageUrl,
              category: event.category || "upcoming",
              registrationLink: event.registrationLink || "",
              status: event.status || "upcoming",
              time: event.time || "",
              organizer: event.organizer || "MASA Forum",
              isActive: event.isActive !== false // Ensure isActive is set
            };
          })
        );

        // Filter out null events (inactive ones)
        const filteredEvents = processedEvents.filter(event => event !== null);

        // Categorize events based on category field
        filteredEvents.forEach(event => {  // Yeh line 210-212 ke beech hai
          if (event.category.toLowerCase() === "program") {
            categorizedEvents.programs.push(event);
          } else if (event.category.toLowerCase() === "past") {
            categorizedEvents.past.push(event);
          } else if (event.category.toLowerCase() === "upcoming") {
            // Only add to upcoming if the event date is in the future (not today or past)
            if (event.rawDate && !isEventDatePast(event.rawDate) && !isEventToday(event.rawDate)) {
              categorizedEvents.upcoming.push(event);
            } else {
              // If date is today or past but marked as upcoming, move to past
              categorizedEvents.past.push(event);
            }
          } else {
            // Default to upcoming if no category specified and date is not past or today
            if (event.rawDate && !isEventDatePast(event.rawDate) && !isEventToday(event.rawDate)) {
              categorizedEvents.upcoming.push(event);
            } else {
              categorizedEvents.past.push(event);
            }
          }
        });

        // Sort events: upcoming by date (ascending), past by date (descending)
        categorizedEvents.upcoming.sort((a, b) => {
          if (!a.rawDate || !b.rawDate) return 0;
          return new Date(a.rawDate) - new Date(b.rawDate);
        });
        categorizedEvents.past.sort((a, b) => {
          if (!a.rawDate || !b.rawDate) return 0;
          return new Date(b.rawDate) - new Date(a.rawDate);
        });
        categorizedEvents.programs.sort((a, b) => {
          if (!a.rawDate || !b.rawDate) return 0;
          return new Date(b.rawDate) - new Date(a.rawDate);
        });

        setEvents(categorizedEvents);
      } catch (err) {
        console.error("Error fetching events:", err);
        setError("Failed to load events. Please try again later.");

        // Fallback to sample data if API fails
        setEvents(getFallbackEvents());
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, [API_EVENTS, API_MEDIA]);

  // Effect to check and move past events from upcoming to past
  useEffect(() => {
    const checkAndUpdateEvents = () => {
      setEvents(prevEvents => {
        const updatedEvents = { ...prevEvents };
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Move past events and today's events from upcoming to past
        const newlyPastEvents = [];
        updatedEvents.upcoming = updatedEvents.upcoming.filter(event => {
          if (event.rawDate && (isEventDatePast(event.rawDate) || isEventToday(event.rawDate))) {
            newlyPastEvents.push(event);
            return false;
          }
          return true;
        });

        // Add newly past events to past category
        if (newlyPastEvents.length > 0) {
          updatedEvents.past = [...newlyPastEvents, ...updatedEvents.past];
          // Re-sort past events
          updatedEvents.past.sort((a, b) => {
            if (!a.rawDate || !b.rawDate) return 0;
            return new Date(b.rawDate) - new Date(a.rawDate);
          });
        }

        return updatedEvents;
      });
    };

    // Check every hour for events that have passed
    const interval = setInterval(checkAndUpdateEvents, 3600000);

    // Initial check
    checkAndUpdateEvents();

    return () => clearInterval(interval);
  }, []);

  // Toggle event expansion
  const toggleEventExpansion = (eventId) => {
    setExpandedEvents((prev) =>
      prev.includes(eventId)
        ? prev.filter((id) => id !== eventId)
        : [...prev, eventId]
    );
  };

  // Open modal with selected image
  const openImageModal = (image) => {
    setSelectedImage(image);
  };

  // Close modal
  const closeImageModal = () => {
    setSelectedImage(null);
  };

  // Function to handle registration button click
  const handleRegisterClick = (eventId) => {
    navigate(`/eventform/${eventId}`);
  };

  // Get current events based on active tab
  const currentEvents = events[activeTab] || [];

  // Get tab display names
  const getTabDisplayName = (tab) => {
    switch (tab) {
      case 'upcoming': return 'Upcoming Events';
      case 'past': return 'Past Events';
      case 'programs': return 'Programs';
      default: return tab;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-gray-100">
      {/* Hero Section */}
      <section className="relative py-16 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-teal-900/20 to-blue-900/20"></div>
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1511578314322-379afb476865?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] opacity-10"></div>
        <div className="container mx-auto px-6 text-center relative z-10">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight">
            Discover Our <span className="bg-gradient-to-r from-teal-400 to-blue-400 bg-clip-text text-transparent">Events & Programs</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-6">
            Empowering MSMEs and Startups through networking, knowledge sharing, and growth opportunities.
          </p>

          {/* Interactive Count Boxes */}
          <div className="flex flex-wrap justify-center gap-4 mt-8">
            {/* Upcoming Events Count Box */}
            <button
              onClick={() => setActiveTab("upcoming")}
              className={`bg-gray-800/50 backdrop-blur-sm rounded-lg p-4 border transition-all duration-300 transform hover:scale-105 hover:shadow-lg cursor-pointer text-left ${activeTab === "upcoming"
                ? "border-teal-500 shadow-lg shadow-teal-500/20"
                : "border-gray-700 hover:border-teal-400/50"
                }`}
            >
              <div className="text-2xl font-bold text-teal-400">{events.upcoming.length}</div>
              <div className="text-sm text-gray-400">Upcoming Events</div>
              {activeTab === "upcoming" && (
                <div className="mt-2 w-full h-1 bg-gradient-to-r from-teal-500 to-blue-500 rounded-full animate-pulse"></div>
              )}
            </button>

            {/* Past Events Count Box */}
            <button
              onClick={() => setActiveTab("past")}
              className={`bg-gray-800/50 backdrop-blur-sm rounded-lg p-4 border transition-all duration-300 transform hover:scale-105 hover:shadow-lg cursor-pointer text-left ${activeTab === "past"
                ? "border-blue-500 shadow-lg shadow-blue-500/20"
                : "border-gray-700 hover:border-blue-400/50"
                }`}
            >
              <div className="text-2xl font-bold text-blue-400">{events.past.length}</div>
              <div className="text-sm text-gray-400">Past Events</div>
              {activeTab === "past" && (
                <div className="mt-2 w-full h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full animate-pulse"></div>
              )}
            </button>

            {/* Active Programs Count Box */}
            <button
              onClick={() => setActiveTab("programs")}
              className={`bg-gray-800/50 backdrop-blur-sm rounded-lg p-4 border transition-all duration-300 transform hover:scale-105 hover:shadow-lg cursor-pointer text-left ${activeTab === "programs"
                ? "border-purple-500 shadow-lg shadow-purple-500/20"
                : "border-gray-700 hover:border-purple-400/50"
                }`}
            >
              <div className="text-2xl font-bold text-purple-400">{events.programs.length}</div>
              <div className="text-sm text-gray-400">Active Programs</div>
              {activeTab === "programs" && (
                <div className="mt-2 w-full h-1 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full animate-pulse"></div>
              )}
            </button>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="container mx-auto px-4 md:px-6 py-8">
        {/* Tab Navigation */}
        <div className="flex flex-col sm:flex-row justify-between items-center mb-10 gap-4">
          <h2 className="text-2xl font-bold text-white">
            {getTabDisplayName(activeTab)}
          </h2>
          <div className="flex bg-gray-800 rounded-xl p-1 shadow-lg">
            {Object.keys(events).map((tab) => (
              <button
                key={tab}
                className={`px-5 py-2 rounded-lg text-sm font-medium transition-all duration-300 flex items-center gap-2 ${activeTab === tab
                  ? "bg-gradient-to-r from-teal-500 to-blue-500 text-white shadow-md"
                  : "text-gray-400 hover:text-white hover:bg-gray-700"
                  }`}
                onClick={() => {
                  setActiveTab(tab);
                  setExpandedEvents([]);
                }}
              >
                {tab === 'upcoming' && <FaCalendarAlt />}
                {tab === 'past' && <FaRegClock />}
                {tab === 'programs' && <FaUserFriends />}
                {getTabDisplayName(tab)}
              </button>
            ))}
          </div>
        </div>

        {/* Loading State */}
        {loading && (
          <div className="text-center py-20">
            <div className="inline-block animate-spin rounded-full h-16 w-16 border-4 border-teal-500 border-t-transparent"></div>
            <p className="mt-6 text-gray-400 text-lg">Loading events...</p>
            <p className="text-gray-500 text-sm mt-2">Please wait while we fetch the latest events</p>
          </div>
        )}

        {/* Error State */}
        {error && !loading && (
          <div className="text-center py-12">
            <div className="bg-gradient-to-r from-red-900/20 to-red-800/20 border border-red-700/50 rounded-xl p-8 max-w-md mx-auto backdrop-blur-sm">
              <div className="w-16 h-16 bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-red-300 mb-2">Connection Error</h3>
              <p className="text-red-200 mb-4">{error}</p>
              <p className="text-gray-400 text-sm">Showing sample events for demonstration.</p>
            </div>
          </div>
        )}

        {/* Events Grid */}
        {!loading && (
          <>
            {currentEvents.length === 0 ? (
              <div className="text-center py-20">
                <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700 rounded-2xl p-12 max-w-lg mx-auto backdrop-blur-sm">
                  <svg className="w-20 h-20 text-gray-600 mx-auto mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <h3 className="text-2xl font-bold text-gray-300 mb-3">No {getTabDisplayName(activeTab)} Found</h3>
                  <p className="text-gray-500 mb-6">
                    {activeTab === 'upcoming'
                      ? "Check back soon for upcoming events and programs."
                      : "We're working on adding more content here. Stay tuned!"}
                  </p>
                  <button
                    onClick={() => setActiveTab(activeTab === 'upcoming' ? 'past' : 'upcoming')}
                    className="px-6 py-3 bg-gradient-to-r from-teal-500 to-blue-500 text-white rounded-lg font-medium hover:from-teal-600 hover:to-blue-600 transition-all duration-300"
                  >
                    View {activeTab === 'upcoming' ? 'Past Events' : 'Upcoming Events'}
                  </button>
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {currentEvents.map((event) => {
                  const isExpanded = expandedEvents.includes(event.id);
                  const registrationClosed = isRegistrationClosed(event);
                  const isToday = isEventToday(event.rawDate);

                  return (
                    <div
                      key={event.id}
                      className="group bg-gradient-to-b from-gray-800/80 to-gray-900/80 rounded-2xl overflow-hidden shadow-2xl transform transition-all duration-500 hover:shadow-2xl hover:scale-[1.02] border border-gray-700 hover:border-teal-500/50 flex flex-col h-full"
                    >
                      {/* Image Section - Fixed Height */}
                      <div
                        className="relative h-64 overflow-hidden cursor-pointer flex-shrink-0"
                        onClick={() => openImageModal(event.image)}
                      >
                        <img
                          src={event.image}
                          alt={event.title}
                          className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-110"
                          onError={(e) => {
                            e.target.src = "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80";
                          }}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent opacity-60"></div>
                        <div className="absolute top-4 right-4">
                          <span className={`px-3 py-1 text-white text-xs font-bold rounded-full shadow-lg ${registrationClosed
                            ? 'bg-gradient-to-r from-green-500 to-green-600'
                            : activeTab === 'upcoming'
                              ? 'bg-gradient-to-r from-teal-500 to-blue-500'
                              : activeTab === 'past'
                                ? 'bg-gradient-to-r from-gray-600 to-gray-700'
                                : 'bg-gradient-to-r from-purple-500 to-purple-600'
                            }`}>
                            {registrationClosed
                              ? ''
                              : activeTab === 'upcoming'
                                ? 'Upcoming'
                                : activeTab === 'past'
                                  ? 'Past Event'
                                  : 'Program'}
                          </span>
                        </div>
                        <div className="absolute bottom-4 left-4 right-4">
                          <div className="flex items-center gap-2 text-white text-sm font-semibold">
                            <FaCalendarAlt className="text-teal-300" />
                            <span>{event.date}</span>
                          </div>
                        </div>
                        {/* Click indicator overlay */}
                        <div className="absolute inset-0 flex items-center justify-center bg-black/0 group-hover:bg-black/30 transition-all duration-300">
                          <div className="opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300 bg-black/50 backdrop-blur-sm px-4 py-2 rounded-lg">
                            <span className="text-white text-sm font-medium flex items-center gap-2">
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                              </svg>
                              Click to view image
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Content Section - Flexible Height */}
                      <div className="p-6 flex flex-col flex-grow">
                        {/* Event Title */}
                        <h3 className="text-xl font-bold text-white mb-3 line-clamp-2 group-hover:text-teal-300 transition-colors duration-300">
                          {event.title}
                        </h3>

                        {/* Event Details */}
                        <div className="space-y-3 mb-4">
                          {/* Location */}
                          {event.location && (
                            <div className="flex items-start gap-2">
                              <FaMapMarkerAlt className="text-blue-400 mt-1 flex-shrink-0" />
                              <span className="text-gray-300 text-sm line-clamp-2">{event.location}</span>
                            </div>
                          )}

                          {/* Time */}
                          {event.time && (
                            <div className="flex items-center gap-2">
                              <FaRegClock className="text-purple-400" />
                              <span className="text-gray-300 text-sm">{event.time}</span>
                            </div>
                          )}
                        </div>

                        {/* Short Description */}
                        <div className="mb-4 flex-grow">
                          {event.description ? (
                            <div
                              className="text-gray-400 text-sm leading-relaxed line-clamp-3"
                              dangerouslySetInnerHTML={{ __html: event.description }}
                            />
                          ) : (
                            <p className="text-gray-400 text-sm italic">No description available</p>
                          )}
                        </div>

                        {/* Full Description with Read More */}
                        {event.fullDescription && (
                          <div className="mb-4">
                            {isExpanded && (
                              <div className="mt-4 pt-4 border-t border-gray-700">
                                <h4 className="text-sm font-semibold text-gray-300 mb-2">Event Details:</h4>
                                <p className="text-gray-400 text-sm leading-relaxed whitespace-pre-line">
                                  {event.fullDescription}
                                </p>
                              </div>
                            )}

                            <button
                              onClick={() => toggleEventExpansion(event.id)}
                              className="flex items-center gap-2 text-teal-400 hover:text-teal-300 font-medium text-sm transition-colors duration-300 group"
                            >
                              {isExpanded ? (
                                <>
                                  <FaChevronUp className="transition-transform duration-300" />
                                  Show Less
                                </>
                              ) : (
                                <>
                                  <FaChevronDown className="transition-transform duration-300 group-hover:translate-y-1" />
                                  Read More Details
                                </>
                              )}
                            </button>
                          </div>
                        )}

                        {/* Action Buttons */}
                        <div className="mt-auto pt-4 border-t border-gray-700">
                          {/* Registration Button for Upcoming Events */}
                          {activeTab === 'upcoming' && (
                            <>
                              {registrationClosed ? (
                                // Show "Registration Closed" if event date is today or past
                                <div className="w-full px-4 py-3 bg-gradient-to-r from-red-600 to-red-700 text-white text-sm font-medium rounded-lg text-center cursor-not-allowed flex items-center justify-center gap-2 opacity-80">
                                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                  </svg>
                                  <span>Registration Closed</span>
                                  {isToday && (
                                    <span className="text-xs text-yellow-300 ml-2">(Event is today)</span>
                                  )}
                                </div>
                              ) : (
                                // Show active registration button for future events only
                                <button
                                  onClick={() => handleRegisterClick(event.id)}
                                  className="w-full px-4 py-3 bg-gradient-to-r from-teal-500 to-blue-500 hover:from-teal-600 hover:to-blue-600 text-white text-sm font-medium rounded-lg text-center cursor-pointer transition-all duration-300 flex items-center justify-center gap-2"
                                >
                                  <FaExternalLinkAlt className="w-3 h-3" />
                                  <span>Register for this Event</span>
                                </button>
                              )}
                            </>
                          )}

                          {/* For programs with HTML links in description */}
                          {activeTab === 'programs' && event.description && event.description.includes('href=') && (
                            <div className="w-full">
                              <div
                                className="px-4 py-3 bg-gradient-to-r from-teal-500 to-blue-500 hover:from-teal-600 hover:to-blue-600 text-white text-sm font-medium rounded-lg text-center cursor-pointer transition-all duration-300"
                                dangerouslySetInnerHTML={{ __html: event.description.replace(/<a /g, '<a class="flex items-center justify-center gap-2" ') }}
                              />
                            </div>
                          )}

                          {/* Default button for programs without links */}
                          {activeTab === 'programs' && (!event.description || !event.description.includes('href=')) && (
                            <button
                              className="w-full px-4 py-3 bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white text-sm font-medium rounded-lg text-center cursor-pointer transition-all duration-300 flex items-center justify-center gap-2"
                            >
                              <FaUserFriends className="w-3 h-3" />
                              <span>Join Program</span>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          onClick={closeImageModal}
        >
          <div
            className="relative max-w-5xl w-full max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-gradient-to-b from-gray-800 to-gray-900 rounded-xl overflow-hidden shadow-2xl border border-gray-700">
              <div className="p-4 border-b border-gray-700 flex justify-between items-center">
                <h3 className="text-white font-medium">Event Image</h3>
                <button
                  className="text-gray-400 hover:text-white transition-colors duration-300 p-2 hover:bg-gray-700 rounded-lg"
                  onClick={closeImageModal}
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div className="p-2">
                <img
                  src={selectedImage}
                  alt="Full size event"
                  className="w-full h-auto max-h-[70vh] object-contain rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default EventsPage;




//old code

// import React, { useState } from "react";
// import Footer from "../components/Footer";

// const EventsPage = () => {
//   const [activeTab, setActiveTab] = useState("upcoming");
//   const [expandedEvents, setExpandedEvents] = useState([]);
//   const [selectedImage, setSelectedImage] = useState(null); // State for modal image

//   const eventsData = {
//     upcoming: [
//       {
//         id: 202,
//         title: "RaipurGrowth Conclave Expo and Awards - Raipur Edition",
//         date: "6th September 2025",
//         location: "Hotel Hyatt, Raipur",
//         description: ' <a href="https://forms.gle/ZvngaRrdrW77zYaAA" target="_blank">Click here to register</a>',
//         fullDescription: `The RaipurGrowth Conclave Expo and Awards 2025 by MASA Forum brings together industry leaders, startups, investors, and policymakers to unlock the future of business. The event features panels, exhibitions, networking, and awards — with a focus on driving growth, innovation, and investment for startups and MSMEs.`,
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/v1758179627/event-imgs/raipurphoto.png",
//       },

//       {
//         id: 203,
//         title: "JampotGrowth Conclave Expo and Awards - Jamshedpur Edition",
//         date: "12th September 2025",
//         location: "Hotel Vivanta, Jamshedpur",
//         description: ' <a href="https://forms.gle/ZvngaRrdrW77zYaAA" target="_blank">Click here to register</a>',
//         fullDescription: `The JampotGrowth Conclave Expo and Awards 2025 by MASA Forum brings together industry leaders, startups, investors, and policymakers to unlock the future of business. The event features panels, exhibitions, networking, and awards — with a focus on driving growth, innovation, and investment for startups and MSMEs.`,
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/Jamshedpurphoto.png",
//       },

//     ],
//     past: [

//       {
//         id: 201,
//         title: "MahaGrowth Conclave Expo and Awards – Mumbai Edition",
//         date: "23rd August 2025",
//         location: "NSE ATRIUM, EXCHANGE PLAZA, Mumbai",
//         description: ' <a href="/MahaGrowth">Click here to View Event</a>',
//         fullDescription: ` The MahaGrowth Conclave Expo and Awards 2025 by MASA Forum brings together industry leaders, startups, investors, and policymakers to unlock the future of business. The event features panels, exhibitions, networking, and awards — with a focus on driving growth, innovation, and investment for startups and MSMEs.`,
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/newmahagrowth.png",
//       },

//       {
//         id: 1,
//         title: "Loan Mela & BFSI Conclave-Expo",
//         date: "17th July 2025",
//         location: "Hotel Hindustan International, Kolkata",
//         description: "",
//         fullDescription: `
//         India’s largest MSME-focused financial event
//         25+ Banks, NBFCs, Fintechs & Funding Experts
//         On-the-spot loan assistance & financial literacy sessions
//         Explore business funding opportunities under one roof  `,
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/loanmela.jpg",
//       },
//       {
//         id: 151,
//         title: "International Yoga Day 2025",
//         date: "21st June 2025",
//         location: "Swarnamani Banquet Hall",
//         // description: "MASA & Swarnamani Pariwar celebrates International Yoga Day",
//         fullDescription: "Celebration of International Yoga Day in Swarnamani Residency. For Morning mindfulness, health and harmony",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/past-yoga-day.webp",
//       },

//       {
//         id: 112,
//         title: "MASA Women's Excellence Conclave, Expo & Awards 2025",
//         date: "6th June 2025",
//         location: "Hotel Astor, Kolkata",
//         description: "",
//         fullDescription: "",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/upcoming2.webp",
//       },

//       {
//         id: 111,
//         title: "Environment Day 2025",
//         date: "5th June 2025",
//         location: "National Library, Kolkata",
//         description: "",
//         fullDescription: "",
//         image: "/images/event-imgs/upcoming11.webp",
//       },

//       // {
//       //   id: 16,
//       //   title: "Startup Pitch Session",
//       //   date: "24 May 2025",
//       //   description: "",
//       //   fullDescription: "",
//       //   image: upcoming4,
//       // },

//       {
//         id: 1,
//         title: "Eastern India Job Fair & career Expo 2025",
//         date: "May 4th-5th, 2025",
//         location: "Indian Council for Cultural Relations (ICCR), Kolkata",
//         //   description:
//         // "Our vision was to establish this event as the leading career & networking event in the region. Organized by Magical Mantras Pvt. Ltd in collaboration with MASA & CWBTA.",
//         fullDescription:
//           "This three-day event featured keynote speeches from tech pioneers, hands-on workshops, and networking opportunities with industry leaders.",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/past11.webp",
//       },
//       {
//         id: 2,
//         title: "Raipur Conclave 2025",
//         date: "April 12th - 13th, 2025",
//         location: "Hotel Sayaji Raipur",
//         description:
//           "",
//         fullDescription:
//           " MASA Raipur Conclave — Connecting Entrepreneurs, Investors & Ecosystem Leaders. The MASA Raipur Conclave was conceived to address the growing need for structured support, visibility, and networking opportunities for MSMEs and startups in Chhattisgarh and surrounding regions.Additionally, the event emphasized inclusivity and women’s leadership through Women’s MASA, encouraging and recognizing women entrepreneurs as vital contributors to the region’s growth story.",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/pastRaipur.webp",
//       },
//       {
//         id: 3,
//         title: "MASA Global Education Conclave & Awards 2025, Kolkata",
//         date: "15 February 2025",
//         location: "National Library, Kolkata",
//         description: "",
//         fullDescription:
//           "This intensive workshop covered SEO, social media marketing, and content strategy with practical case studies and actionable insights.",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/past10.webp",
//       },
//       {
//         id: 4,
//         title: "MSME & Startup Accelerator Conclave & Awards 2025",
//         date: "8 February 2025",
//         location: "National Library, Kolkata",
//         description: "",
//         fullDescription:
//           "This intensive workshop covered SEO, social media marketing, and content strategy with practical case studies and actionable insights.",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/past9.webp",
//       },
//       {
//         id: 5,
//         title: "MASA Sanskriti Pranam 2024",
//         date: "19 December, 2024",
//         location: "Silpa Sadan, Kolkata",
//         description: "",
//         fullDescription:
//           "This intensive workshop covered SEO, social media marketing, and content strategy with practical case studies and actionable insights.",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/past8.webp",
//       },
//       {
//         id: 6,
//         title: "MASA Metals' Conclave 2024, Bhubaneswar",
//         date: "18 September, 2024",
//         location: "Hotel New Marrion, Bhubaneshwar",
//         description: "",
//         fullDescription:
//           "This intensive workshop covered SEO, social media marketing, and content strategy with practical case studies and actionable insights.",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/past7.webp",
//       },
//       {
//         id: 7,
//         title: "Inter College Business & Financial Conclave & Quiz 2024",
//         date: "12 September, 2024",
//         location: "IEM Auditorium, Ashram Building",
//         description: "",
//         fullDescription:
//           "This intensive workshop covered SEO, social media marketing, and content strategy with practical case studies and actionable insights.",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/past6.webp",
//       },
//       {
//         id: 8,
//         title: "MASA Metals' Conclave 2024, Kolkata",
//         date: "August 21, 2024",
//         location: "Hotel Hindustan International, Kolkata",
//         description: "",
//         fullDescription:
//           "This intensive workshop covered SEO, social media marketing, and content strategy with practical case studies and actionable insights.",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/past5.webp",
//       },
//       {
//         id: 9,
//         title: "Environment Quiz 2024, Kolkata",
//         date: "10 August, 2024",
//         location: "National Library, Kolkata",
//         description: "",
//         fullDescription:
//           "This intensive workshop covered SEO, social media marketing, and content strategy with practical case studies and actionable insights.",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/past4.webp",
//       },
//       {
//         id: 10,
//         title: "MASA Conclave & Awards 2024, New Delhi",
//         date: "June 13, 2024",
//         location: "PhD Chamber of Commerce, New Delhi",
//         description: "",
//         fullDescription:
//           "This intensive workshop covered SEO, social media marketing, and content strategy with practical case studies and actionable insights.",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/past3.webp",
//       },
//       {
//         id: 11,
//         title: "MASA Women's Excellence Conclave & Awards 2024",
//         date: "March 10, 2024",
//         location: "JW Marriott, Kolkata",
//         description: "",
//         fullDescription:
//           "This intensive workshop covered SEO, social media marketing, and content strategy with practical case studies and actionable insights.",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/past2.webp",
//       },
//       {
//         id: 12,
//         title: "MSME & Startup Accelerator Conclave & Awards 2024",
//         date: "January 28, 2024",
//         location: "Indian Council for Cultural Relations, Kolkata",
//         description: "",
//         fullDescription:
//           "This intensive workshop covered SEO, social media marketing, and content strategy with practical case studies and actionable insights.",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/past1.webp",
//       },
//     ],
//     programs: [
//       {
//         id: 13,
//         title: "MASA Monthly Connect",
//         date: "Every month 3rd Week Thursday",
//         description: "An offline meet at CWBTA Office for all members and non-members",
//         fullDescription: "Exact Dates details to be announced in our Whatsapp channel. This MASA CONNECT meet is to empower MSMEs & startups through monthly engagements. Be a part of nation's thriving MSMEs & Startups ecosystem",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/MASA-connect1.webp",
//       },
//       {
//         id: 14,
//         title: "Leadership Development Program",
//         date: "June 5 - July 10, 2025",
//         location: "Corporate Headquarters",
//         description: "Six-week intensive leadership training",
//         fullDescription:
//           "This program includes mentorship sessions, team projects, and leadership simulations designed to develop executive-level skills.",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/leadershipProgram.JPG.webp",
//       },
//       {
//         id: 15,
//         title: "Gem Portal training",
//         date: "21 May 2025",
//         description: "",
//         fullDescription: "",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/gem.webp",
//       },
//       {
//         id: 16,
//         title: "Mentoring MSMEs on Pmegp",
//         date: "23 May 2025",
//         description: "",
//         fullDescription: "",
//         image: "https://res.cloudinary.com/dnmlijyox/image/upload/event-imgs/pmepg.webp",
//       },
//     ],
//   };

//   // Toggle event expansion
//   const toggleEventExpansion = (eventId) => {
//     setExpandedEvents((prev) =>
//       prev.includes(eventId)
//         ? prev.filter((id) => id !== eventId)
//         : [...prev, eventId]
//     );
//   };

//   // Open modal with selected image
//   const openImageModal = (image) => {
//     setSelectedImage(image);
//   };

//   // Close modal
//   const closeImageModal = () => {
//     setSelectedImage(null);
//   };

//   return (
//     <div className="min-h-screen bg-gray-900 text-gray-100">
//       {/* Compact Hero Section */}
//       <section className="relative py-12">
//         <div className="absolute inset-0 bg-gray-900 opacity-30"></div>
//         <div className="container mx-auto px-6 text-center relative z-10">
//           <h1 className="text-2xl md:text-3xl font-extrabold mb-2 leading-tight">
//             Explore Our Events for{" "}
//             <span className="text-teal-400">MSMEs and Startups</span>
//           </h1>
//           <p className="text-lg text-gray-300 max-w-3xl mx-auto">
//             From startup pitch events and innovation workshops to MSME
//             accelerator programs — discover hands-on opportunities that drive
//             real growth.
//           </p>
//         </div>
//       </section>

//       {/* Main Content */}
//       <section className="container mx-auto -mt-8 px-6 py-8">
//         {/* Tab Navigation */}
//         <div className="flex justify-center mb-8 bg-gray-800 rounded-full p-1 max-w-md mx-auto shadow-lg">
//           {Object.keys(eventsData).map((tab) => (
//             <button
//               key={tab}
//               className={`flex-1 py-2 px-4 rounded-full text-xs sm:text-sm font-semibold uppercase tracking-wide transition-all duration-300 ${activeTab === tab
//                   ? "bg-teal-500 text-white shadow-md"
//                   : "text-gray-400 hover:text-white hover:bg-gray-700"
//                 }`}
//               onClick={() => {
//                 setActiveTab(tab);
//                 setExpandedEvents([]);
//               }}
//             >
//               {tab}
//             </button>
//           ))}
//         </div>

//         {/* Events Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {eventsData[activeTab].map((event) => (
//             <div
//               key={event.id}
//               className="bg-gray-800 rounded-xl overflow-hidden shadow-lg transform transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
//             >
//               <div className="relative h-48">
//                 <img
//                   src={event.image}
//                   alt={event.title}
//                   className="w-full h-full object-cover transition-transform duration-500 hover:scale-105 cursor-pointer"
//                   onClick={() => openImageModal(event.image)}
//                 />
//                 <span className="absolute top-3 right-3 bg-teal-500 text-white text-xs font-semibold px-2 py-1 rounded-full">
//                   {event.date}
//                 </span>
//               </div>
//               <div className="p-5">
//                 <h3 className="text-lg font-bold text-white mb-1">
//                   {event.title}
//                 </h3>
//                 <p className="text-gray-400 text-s mb-2">{event.location}</p>
//                 <p
//                   className="text-blue-300 text-s mb-3"
//                   dangerouslySetInnerHTML={{ __html: event.description }}
//                 ></p>

//                 {expandedEvents.includes(event.id) && (
//                   <div className="mt-3 pt-3 border-t border-gray-700 text-gray-300 text-s animate-fade-in">
//                     {event.fullDescription}
//                   </div>
//                 )}

//                 <button
//                   className={`text-s font-semibold transition-colors duration-300 ${expandedEvents.includes(event.id)
//                       ? "text-gray-400 hover:text-white"
//                       : "text-teal-400 hover:text-teal-300"
//                     }`}
//                   onClick={() => toggleEventExpansion(event.id)}
//                 >
//                   {expandedEvents.includes(event.id) ? "Show Less" : "Read More"}
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Image Modal (unchanged) */}
//       {selectedImage && (
//         <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
//           <div className="relative max-w-4xl w-full mx-4">
//             <img
//               src={selectedImage}
//               alt="Full size event"
//               className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
//             />
//             <button
//               className="absolute top-4 right-4 bg-gray-800 text-white p-2 rounded-full hover:bg-gray-700 transition-colors"
//               onClick={closeImageModal}
//             >
//               <svg
//                 className="w-6 h-6"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M6 18L18 6M6 6l12 12"
//                 />
//               </svg>
//             </button>
//           </div>
//         </div>
//       )}

//       <Footer />
//     </div>
//   );
// };

// export default EventsPage;


